<script setup></script>

<template>
  <div
    class="!mb-3 !rounded-br-sm-md !rounded-tl-sm-md !rounded-tr-sm-md !bg-white !bg-opacity-60 !px-7 !py-6 !text-base"
  >
    <slot />
  </div>
</template>
